var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('li',{staticClass:"infoList"},[_c('span',{staticClass:"infoListLeft"},[_vm._v(_vm._s(_vm.obj.label))]),_c('span',{staticClass:"infoListRight"},[_vm._v(_vm._s(_vm.obj.firstUnit)+" "+_vm._s(_vm.obj.value)+" "+_vm._s(_vm.obj.lastUnit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }